<template>
  <v-container fluid class="pa-0 overflow-hidden home-page">
    <!-- ===== HERO ===== -->
    <section class="hero-section">
      <div class="margin-header"></div>
      <div class="home-wrap">
        <v-row align="center" class="ma-0 ">
          <v-col cols="12" md="6" class="pr-md-10 reveal">
            <h1 class="hero-title">
              {{ t.hero.title1 }}<br />
              <span class="text-primary-blue">{{ t.hero.title2 }}</span>
            </h1>
            <p class="hero-desc">{{ t.hero.desc }}</p>
            <div class="btn-group">
              <!-- @click="onClickMenu('/register-account')" -->
              <v-btn depressed dark color="#205295" height="48" class="home-btn px-6" @click="onClickMenu('/register-account')">
                {{ t.startFree }}
              </v-btn>
              <v-btn outlined color="#205295" height="48" class="home-btn px-6 bg-white" @click="onClickMenu('/feature')">
                {{ t.hero.viewFeatures }}
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="6" class="reveal">
            <div class="hero-img-wrap">
              <v-img src="@/assets/img-hero-video.jpg" height="350" class="hero-img"></v-img>
              <div class="pdpa-badge">
                <div class="pdpa-icon">
                  <v-icon small color="#205295">mdi-shield-outline</v-icon>
                </div>
                <span>{{ t.hero.pdpa }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </section>

    <!-- ===== FEATURES ===== -->
    <section class="home-section reveal">
      <div class="home-wrap">
        <div class="section-head">
          <h2 class="section-title">{{ t.features.title }}</h2>
          <p class="section-sub">{{ t.features.sub }}</p>
        </div>
        <v-row>
          <v-col v-for="(f, i) in t.features.items" :key="i" cols="12" sm="6" md="3">
            <div class="feature-card">
              <div class="icon-box">
                <v-icon size="20" color="#205295">{{ featureIcons[i] }}</v-icon>
              </div>
              <h3 class="card-title">{{ f.title }}</h3>
              <p class="card-desc">{{ f.desc }}</p>
            </div>
          </v-col>
        </v-row>
      </div>
    </section>

    <!-- ===== ORGANIZATIONS ===== -->
    <section class="home-section bg-soft reveal">
      <div class="home-wrap">
        <div class="section-head">
          <h2 class="section-title">{{ t.orgs.title }}</h2>
          <p class="section-sub">{{ t.orgs.sub }}</p>
        </div>
        <v-row>
          <v-col v-for="(o, i) in t.orgs.items" :key="i" cols="12" md="4">
            <div class="org-card">
              <v-img :src="orgImages[i]" height="160"></v-img>
              <div class="org-body">
                <h3 class="org-title">{{ o.title }}</h3>
                <p class="card-desc ma-0">{{ o.desc }}</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </section>

    <!-- ===== WHY CHOOSE ===== -->
    <section class="home-section reveal">
      <div class="home-wrap">
        <div class="section-head">
          <h2 class="section-title">{{ t.why.title }}</h2>
          <p class="section-sub">{{ t.why.sub }}</p>
        </div>
        <v-row>
          <v-col v-for="(w, i) in t.why.items" :key="i" cols="12" md="6">
            <div class="why-card">
              <div class="dot-wrap"><span class="dot"></span></div>
              <div>
                <h3 class="why-title">{{ w.title }}</h3>
                <p class="card-desc ma-0">{{ w.desc }}</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </section>

    <!-- ===== MOBILE APP ===== -->
    <section class="app-section">
    <!-- <span class="app-circle"></span> -->
      <div class="home-wrap">
        <v-row align="center" class="ma-0 reveal">
          <v-col cols="12" md="6" class="text-center text-md-left">
            <div class="app-eyebrow">
              <span class="line"></span>{{ t.app.eyebrow }}<span class="line"></span>
            </div>
            <h2 class="app-title">{{ t.app.title1 }}<br />{{ t.app.title2 }}</h2>
            <p class="app-desc">{{ t.app.desc }}</p>
            <div class="btn-group justify-center justify-md-start">
              <a class="store-btn" @click="openLink(appStoreUrl)">
                <v-icon color="white" size="22">mdi-apple</v-icon>
                <div><small>DOWNLOAD ON THE</small><strong>App Store</strong></div>
              </a>
              <a class="store-btn" @click="openLink(playStoreUrl)">
                <v-icon color="white" size="22">mdi-google-play</v-icon>
                <div><small>GET IT ON</small><strong>Google Play</strong></div>
              </a>
            </div>
          </v-col>
             <v-col cols="12" md="6">
            <div class="phones">
              <img src="@/assets/ui_dmeets_mobile_login.png" alt="Dmeets sign in" class="phone phone-back" />
              <img src="@/assets/ui_dmeets_mobile_createroom.png" alt="Dmeets create meeting" class="phone phone-front" />
            </div>
          </v-col>
        </v-row>
      </div>
    </section>

    <!-- ===== CTA ===== -->
    <section class="cta-section">
      <div class="reveal">
      <h2 class="cta-title">{{ t.cta.title }}</h2>
      <p class="cta-sub">{{ t.cta.sub }}</p>
      <div class="btn-group justify-center">
        <!--  @click="onClickMenu('/register-account')" -->
        <v-btn depressed color="white" height="46" class="home-btn px-6 cta-primary" @click="onClickMenu('/register-account')">
          {{ t.startFree }}
        </v-btn>
        <v-btn outlined color="white" height="46" class="home-btn px-6" @click="onClickMenu('/contact')">
          {{ t.cta.contact }}
        </v-btn>
      </div>
      </div>
    </section>

    <!-- ===== PRIVACY SNACKBAR ===== -->
    <v-snackbar
      v-if="showpop"
      v-model="privacyDlg"
      bottom
      max-width="1000"
      width="auto"
      :timeout="-1"
      :vertical="$vuetify.breakpoint.smAndDown"
      color="white"
      light
      class="privacy-snackbar"
    >
      <div class="d-flex align-center">
        <v-avatar size="36" color="#EEF1F5" class="mr-4 flex-shrink-0">
          <v-icon small color="#4A5568">mdi-cookie-outline</v-icon>
        </v-avatar>
        <span class="privacy-text">
          {{ lg_policy.message }}
          <a @click="showPrivacyPolicy_1()">{{ lg_footer.privacy_policy }}</a>
          {{ lg_policy.and }}
          <a @click="showDmeetsdocx_4()">{{ lg_footer.terms_and_conditions }}</a>.
        </span>
      </div>

      <template #action="{ attrs }">
        <div class="privacy-actions">
          <v-btn v-bind="attrs" depressed dark color="#205295" class="privacy-btn" @click="onclickPrivacyDlg()">
            I Agree
          </v-btn>
          <v-btn v-bind="attrs" outlined color="#000000" class="privacy-btn" @click="privacyDlg = false">
            <span class="dismiss-text">Dismiss</span>
          </v-btn>
        </div>
      </template>
    </v-snackbar>

    <!-- <back-to-top :threshold="400" :duration="600" /> -->
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server, feature } from "../services/constants";
import { lg_mainpage } from "./language/lg_header_mainpage.js";
import { lg_policy } from "./language/lg_policy";
import { lg_header_feature } from "./language/lg_header_feature.js";
import { lg_header_menu } from "./language/lg_header_menu.js";
import { lg_footer } from "./language/lg_footer.js";
import BackToTop from "@/components/core/Backtotop.vue";

const CONTENT = {
  en: {
    startFree: "Start Free",
    hero: {
      title1: "Secure Online Meetings",
      title2: "You Can Trust",
      desc: "Dmeets is a Thai-developed video conferencing platform designed for modern businesses, educators, and organizations that need secure, reliable, and privacy-conscious online meetings.",
      viewFeatures: "View All Features",
      pdpa: "PDPA Compliant",
    },
    features: {
      title: "Complete Feature Set",
      sub: "Everything you need for productive online meetings",
      items: [
        { title: "HD Video Meetings", desc: "Crystal clear HD video and audio for every meeting" },
        { title: "Screen Sharing", desc: "Share your content with a single click" },
        { title: "Chat & File Sharing", desc: "Communicate and share documents instantly" },
        { title: "Meeting Recording", desc: "Record and store meetings" },
        { title: "In-Meeting Voting", desc: "Real-time voting and polls" },
        { title: "Meeting Vote Report", desc: "Voting results and analytics from in-meeting polls" },
        { title: "PDPA Compliant", desc: "Secure and compliant with Thai data protection laws" },
        { title: "Legal Advisors", desc: "Professional meeting minutes by licensed legal experts" },
      ],
    },
    orgs: {
      title: "Perfect for Every Organization",
      sub: "Whether you're a business, educational institution, or government agency",
      items: [
        { title: "Business & SMEs", desc: "Professional team and client meetings with enterprise-grade security and reliability." },
        { title: "Educational Institutions", desc: "Seamless online teaching and learning with built-in recording and collaboration tools." },
        { title: "Organizations", desc: "Secure official meetings with professional minutes prepared by certified legal advisors." },
      ],
    },
    why: {
      title: "Why Choose Dmeets?",
      sub: "Reasons why businesses trust us as their partner",
      items: [
        { title: "Developed in Thailand", desc: "Built to understand Thai business needs with full Thai language support and local customer service." },
        { title: "Built for Security and Trust", desc: "Designed with PDPA-conscious data handling, secure communication, transparent recording notifications, and responsible meeting controls — so you can meet with confidence." },
        { title: "Affordable Pricing", desc: "Flexible plans for every organization size. Start free with no credit card required." },
        { title: "Recordings Stored in Thailand", desc: "Meeting recording files are stored in AWS S3 Thailand region, supporting Thai data residency for recorded meeting files." },
      ],
    },
    app: {
      eyebrow: "DMEETS MOBILE APP",
      title1: "Meet anywhere,",
      title2: "on any device.",
      desc: "Join, create and manage secure video meetings from your phone. Dmeets is available for iOS and Android.",
    },
    cta: {
      title: "Ready to Get Started?",
      sub: "Try it free, no credit card required",
      contact: "Contact Us",
    },
  },
  th: {
    startFree: "เริ่มฟรี",
    hero: {
      title1: "การประชุมออนไลน์",
      title2: "ที่จัดเก็บข้อมูลในประเทศไทย",
      desc: "Dmeets คือแพลตฟอร์มประชุมออนไลน์ที่พัฒนาโดยคนไทย ออกแบบมาสำหรับธุรกิจ สถาบันการศึกษา และองค์กรที่ต้องการการประชุมออนไลน์ที่ปลอดภัย และเก็บข้อมูลไว้ภายในประเทศ",
      viewFeatures: "ดูฟีเจอร์ทั้งหมด",
      pdpa: "ปฏิบัติตาม PDPA",
    },
    features: {
      title: "ฟีเจอร์ครบครัน",
      sub: "ทุกสิ่งที่คุณต้องการสำหรับการประชุมออนไลน์",
      items: [
        { title: "ประชุมวิดีโอ HD", desc: "วิดีโอและเสียง HD คุณภาพสูงสำหรับทุกการประชุม" },
        { title: "แชร์หน้าจอ", desc: "แชร์เนื้อหาของคุณด้วยคลิกเดียว" },
        { title: "แชทและแชร์ไฟล์", desc: "สื่อสารและแชร์เอกสารได้ทันที" },
        { title: "บันทึกการประชุม", desc: "บันทึกและจัดเก็บการประชุมไว้ในประเทศไทย" },
        { title: "โหวตในการประชุม", desc: "โหวตและโพลแบบเรียลไทม์" },
        { title: "รายงานการโหวต", desc: "ผลการโหวตและการวิเคราะห์จากโพลในการประชุม" },
        { title: "ปฏิบัติตาม PDPA", desc: "ปลอดภัยและปฏิบัติตามกฎหมายคุ้มครองข้อมูลไทย" },
        { title: "ที่ปรึกษากฎหมาย", desc: "รับทำรายงานการประชุมโดยทนายความที่ปรึกษา" },
      ],
    },
    orgs: {
      title: "เหมาะกับทุกองค์กร",
      sub: "ไม่ว่าจะเป็นธุรกิจ สถานศึกษา หรือหน่วยงานรัฐ",
      items: [
        { title: "ธุรกิจและ SME", desc: "การประชุมทีมและลูกค้าระดับมืออาชีพ ด้วยความปลอดภัยระดับองค์กร" },
        { title: "สถาบันการศึกษา", desc: "การสอนและเรียนรู้ออนไลน์ที่ราบรื่น พร้อมระบบบันทึกและเครื่องมือในการสอน" },
        { title: "องค์กร", desc: "การประชุมทางการที่ปลอดภัย พร้อมรายงานการประชุมโดยที่ปรึกษากฎหมายที่ผ่านการรับรอง" },
      ],
    },
    why: {
      title: "ทำไมต้องเลือก Dmeets?",
      sub: "เหตุผลที่ธุรกิจเชื่อถือเราในฐานะพันธมิตร",
      items: [
        { title: "พัฒนาในประเทศไทย", desc: "สร้างขึ้นเพื่อเข้าใจความต้องการของธุรกิจไทย พร้อมรองรับภาษาไทยเต็มรูปแบบและบริการลูกค้าในไทย" },
        { title: "สร้างเพื่อความปลอดภัยและความไว้วางใจ", desc: "ออกแบบโดยคำนึงถึง PDPA การสื่อสารที่ปลอดภัย การแจ้งเตือนการบันทึกอย่างโปร่งใส — เพื่อให้คุณประชุมได้อย่างมั่นใจ" },
        { title: "ราคาที่ย่อมเยา", desc: "ราคาที่เหมาะสำหรับทุกขนาดองค์กร เริ่มใช้งานฟรีโดยไม่ต้อผูกบัตรเครดิต" },
        { title: "เก็บการบันทึกการประชุมในประเทศไทย", desc: "ไฟล์บันทึกการประชุมถูกเก็บใน AWS S3 ภูมิภาคไทย รองรับการจัดเก็บการประชุมในไทย" },
      ],
    },
    app: {
      eyebrow: "DMEETS MOBILE APP",
      title1: "ประชุมได้ทุกที่",
      title2: "ทุกเวลา",
      desc: "เข้าร่วม สร้าง และจัดการประชุมออนไลน์ง่ายๆ ผ่านมือถือของคุณ Dmeets รองรับทั้งระบบ iOS และ Android ดาวน์โหลดเลยวันนี้",
    },
    cta: {
      title: "พร้อมเริ่มต้นแล้วหรือยัง?",
      sub: "ลองฟรี ไม่ต้องใช้บัตรเครดิต",
      contact: "ติดต่อเรา",
    },
  },
};

export default {
  name: "main-page",
  components: { BackToTop },
  data: () => ({
    checklanguage: "",
    showpop: false,
    dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .replace("T", " ")
      .substr(0, 16),
    margincardpriceplans: "mx-auto ml-0 mt-0 mr-0 mb-0",
    privacy_sta: "false",
    privacyDlg: false,
    scrollHandler: null,
    timers: [],
    // TODO: ใส่ลิงก์ store จริง
    appStoreUrl: "https://apps.apple.com/th/app/dmeets/id6479974253",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.dcm.dmeetszoom.dcm_dmeetszoom",
    featureIcons: [
      "mdi-video-outline",
      "mdi-share-variant-outline",
      "mdi-message-outline",
      "mdi-clock-outline",
      "mdi-chart-bar",
      "mdi-file-document-outline",
      "mdi-shield-outline",
      "mdi-account-group-outline",
    ],
    orgImages: [
      require("@/assets/img-business-meeting.jpg"),
      require("@/assets/img-education.jpg"),
      require("@/assets/img-organizations.jpg"),
    ],
  }),
  computed: {
    t() {
      return localStorage.getItem(feature.LANGUAGE) === "th" ? CONTENT.th : CONTENT.en;
    },
    buttonsmall() {
      return this.$vuetify.breakpoint.name === "xs";
    },
  },
  async beforeCreate() {
    this.$store.state.page_reload = false;
    this.$store.state.loadFooter = true;
    const isTh = localStorage.getItem(feature.LANGUAGE) === "th";
    this.lg_footer = isTh ? lg_footer.lg_footer_th : lg_footer.lg_footer_en;
    this.lg_mainpage = isTh ? lg_mainpage.lg_mainpage_th : lg_mainpage.lg_mainpage_en;
    this.lg_policy = isTh ? lg_policy.policy_th : lg_policy.policy_en;
    this.lg_header_feature = isTh ? lg_header_feature.lg_header_feature_th : lg_header_feature.lg_header_feature_en;
    this.lg_header_menu = isTh ? lg_header_menu.lg_header_menu_th : lg_header_menu.lg_header_menu_en;
  },
  created() {
    this.setpopupdialog("");
    this.onResize();
    this.$store.state.meetSta = false;
  },
   beforeDestroy() {
    this.cleanup();
  },
  beforeUnmount() {
    this.cleanup();
  },
  async mounted() {
    this.checklanguage = localStorage.getItem(feature.LANGUAGE);
    localStorage.removeItem(feature.GET_BUY_NOW);
    this.onResize();

         // ให้ animation แสดงครั้งแรกครั้งเดียว
    // this.$el.querySelectorAll(".reveal").forEach((el, i) => {
    //   this.timers.push(
    //     setTimeout(() => el.classList.add("reveal--visible"), 200 + i * 150)
    //   );
    // });
    // animation (เหมือนหน้า About)
    const targets = Array.from(this.$el.querySelectorAll(".reveal"));
    const inView = (el) => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const rect = el.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < vh - 100;
    };

    // 1) ตอนโหลดหน้า: ส่วนที่อยู่ในจอสไลด์ขึ้นทีละตัว
    let order = 0;
    targets.forEach((el) => {
      if (inView(el)) {
        this.timers.push(
          setTimeout(() => el.classList.add("reveal--visible"), 200 + order++ * 150)
        );
      }
    });

    // 2) ตอน scroll: fade in เมื่อเข้าจอ / fade out เมื่อออกจอ
    this.scrollHandler = () =>
      targets.forEach((el) => el.classList.toggle("reveal--visible", inView(el)));
    document.addEventListener("scroll", this.scrollHandler);



    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      const response = await api.checkIfUserAgreed(userId);
      if (!response || !response.data || !response.data.id) {
        this.privacyDlg = true;
      }
    } else {
      try {
        if (this.$store.state.checklinkmeeting === true) {
          throw new Error(this.lg_mainpage.contentmeeterror);
        }
        if (this.$store.state.checkidmeeting === true) {
          this.$swal.fire(this.lg_mainpage.titlemeeterror, this.lg_mainpage.contentmeetiderror, "error");
        }
      } catch (error) {
        if (error.response?.status === 404) {
          this.$swal.fire(this.lg_mainpage.titlemeeterror, this.lg_mainpage.contentmeetiderror, "error");
        } else {
          this.$swal.fire(this.lg_mainpage.titlemeeterror, error?.message, "error");
        }
      }
      this.privacyDlg = true;
    }

  },
  methods: {
      cleanup() {
      if (this.scrollHandler) {
        document.removeEventListener("scroll", this.scrollHandler);
        this.scrollHandler = null;
      }
      this.timers.forEach(clearTimeout);
      this.timers = [];
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    showPrivacyPolicy_1() {
      window.open(`${window.location.origin}/privacy-policy`);
    },
    showDmeetsdocx_4() {
      if (this.checklanguage == "th") {
        window.open(`${window.location.origin}/DCM_Terms_and_Conditions_(TH).pdf`);
      } else {
        window.open(`${window.location.origin}/DCM_Terms_and_conditions_(ENG).pdf`);
      }
    },
    async onclickPrivacyDlg() {
      if (api.isLoggedIn()) {
        const userId = localStorage.getItem(server.USER_ID);
        const username = localStorage.getItem(server.FULLNAME);
        if (userId) {
          const body = { account_id: userId, account_name: username, device_platform: "web" };
          try {
            const response = await api.createPDPA(body);
            if (response && response.data && response.data.id) {
              this.privacyDlg = false;
            }
          } catch (e) {
            console.log(e.message);
          }
        }
      } else {
        this.privacyDlg = false;
      }
      this.setpopupdialog("clicked");
    },
    onclickNonPrivacyDlg() {
      window.open(`http://${window.location.host}/privacy-policy`);
    },
    async onResize() {
      this.margincardpriceplans = this.$vuetify.breakpoint.smAndDown
        ? "mx-auto ml-5 mt-5 mr-5 mb-5"
        : "mx-auto ml-0 mt-0 mr-0 mb-0";
    },
    async setpopupdialog(data) {
      const day = 1 * 24;
      const setdateexpired = new Date(new Date().setHours(new Date().getHours() + (day + 7)))
        .toISOString()
        .replace("T", " ")
        .substr(0, 16);

      if (data === "clicked") {
        this.showpop = false;
        this.$cookies.set("sessionpopup", { name: "checkclickpopup", expired: setdateexpired }, setdateexpired);
      } else {
        const cookie = this.$cookies.get("sessionpopup");
        if (cookie && new Date(cookie.expired) <= new Date(this.dateNow)) {
          this.showpop = true;
          this.$cookies.remove("sessionpopup");
        } else if (cookie && new Date(cookie.expired) >= new Date(this.dateNow)) {
          this.showpop = false;
        } else {
          this.showpop = true;
        }
      }
    },
    onClickMenu(link) {
      this.$router.push(link).catch(() => {});
    },
  },
};
</script>

<style scoped>
.home-page {
  --blue: #205295;
  --blue-dark: #1f4e96;
  --text: #0f172a;
  --muted: #4b5563;
  --border: #e5e7eb;
  color: var(--text);
}

.home-wrap {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 24px;
}

.margin-header {
  height: 64px;
}

/* ---------- Common ---------- */
.home-section {
  padding: 80px 0;
}
.bg-soft {
  background: #f8fafc;
}
.section-head {
  text-align: center;
  margin-bottom: 48px;
}
.section-title {
  font-size: 32px;
  font-weight: 500;
  color: var(--text);
  margin-bottom: 8px;
}
.section-sub {
  font-size: 17px;
  color: var(--muted);
  margin: 0;
}
.card-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--text);
  margin: 16px 0 6px;
}
.card-desc {
  font-size: 14px;
  line-height: 1.6;
  color: var(--muted);
}
.btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}
.home-btn {
  border-radius: 6px;
  text-transform: none;
  letter-spacing: normal;
  font-size: 15px;
  font-weight: 500;
}
.bg-white {
  background: #fff;
}
.text-primary-blue {
  color: var(--blue);
}

/* ---------- Hero ---------- */
.hero-section {
  background: linear-gradient(180deg, #eaf3fe 0%, #ffffff 100%);
  padding-bottom: 80px;
}
.hero-title {
  font-size: 56px;
  font-weight: 500;
  line-height: 1.25;
  margin: 32px 0 24px;
}
.hero-desc {
  font-size: 18px;
  line-height: 1.6;
  color: #374151;
  margin-bottom: 24px;
}
.hero-img-wrap {
  position: relative;
  padding-left: 24px;
}
.hero-img {
  border-radius: 10px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.15);
}
.pdpa-badge {
  position: absolute;
  left: 0;
  bottom: -24px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  padding: 14px 20px;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
  font-size: 15px;
  font-weight: 500;
}
.pdpa-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ---------- Features ---------- */
.feature-card {
  height: 100%;
  padding: 24px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
}
.feature-card,
.org-card,
.why-card {
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}
.feature-card:hover {
  transform: translateY(-6px);
  border-color: #bcd3f5;
  box-shadow: 0 14px 32px rgba(32, 82, 149, 0.14);
}
.icon-box {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: #eef3fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ---------- Organizations ---------- */
.org-card {
  height: 100%;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
}
.org-card:hover {
  transform: translateY(-6px);
  border-color: #bcd3f5;
  box-shadow: 0 14px 32px rgba(32, 82, 149, 0.14);
}
.org-body {
  padding: 20px;
}
.org-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}

/* ---------- Why ---------- */
.why-card {
  height: 100%;
  display: flex;
  gap: 20px;
  padding: 24px;
  border: 1px solid var(--border);
  border-radius: 8px;
}
.why-card:hover {
  transform: translateY(-6px);
  border-color: #bcd3f5;
  box-shadow: 0 14px 32px rgba(32, 82, 149, 0.14);
}
.dot-wrap {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #eef3fa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--blue);
}
.why-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}

/* ---------- Mobile App ---------- */
.app-section {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #1d4a8f 0%, #2a74c4 100%);
}
.app-circle {
  position: absolute;
  top: 50px;
  left: 38%;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  pointer-events: none;
}

.phones {
  position: relative;
  width: 360px;
  height: 480px;
  margin-left: auto;
}
.phone {
  position: absolute;
  width: 196px;
  height: auto;
  filter: drop-shadow(0 24px 40px rgba(0, 0, 0, 0.35));
}
.phone-back {
  left: 0;
  top: 50px;
  z-index: 1;
}
.phone-front {
  right: 0;
  top: 0;
  z-index: 2;
}

@media (max-width: 959px) {
  .phones {
    margin: 32px auto 0;
    width: 300px;
    height: 400px;
  }
  .phone {
    width: 164px;
  }
  .phone-back {
    top: 40px;
  }
  .app-circle {
    display: none;
  }
}
.app-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.8);
}
.app-eyebrow .line {
  width: 28px;
  height: 1px;
  background: rgba(255, 255, 255, 0.5);
}
.app-title {
  font-size: 44px;
  font-weight: 400;
  line-height: 1.25;
  margin: 16px 0 24px;
   color: rgba(255, 255, 255, 0.8);
}
.app-desc {
  font-size: 17px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.85);
  max-width: 440px;
  margin-bottom: 28px;
}
.text-md-left .app-desc {
  margin-left: 0;
}
.store-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #000;
  color: #fff !important;
  padding: 8px 18px;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
}
.store-btn div {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  text-align: left;
}
.store-btn small {
  font-size: 9px;
  letter-spacing: 0.5px;
}
.store-btn strong {
  font-size: 17px;
  font-weight: 600;
}
.app-img {
  max-width: 100%;
  max-height: 460px;
}

/* ---------- CTA ---------- */
.cta-section {
  background: var(--blue-dark);
  color: #fff;
  text-align: center;
  padding: 72px 24px;
}
.cta-title {
  font-size: 34px;
  font-weight: 500;
  margin-bottom: 12px;
}
.cta-sub {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 28px;
}
.cta-primary {
  color: var(--blue) !important;
}


/* ---------- Privacy snackbar ---------- */
.privacy-actions {
  display: flex;
  gap: 12px;
}
.privacy-btn {
  width: 100px;
  height: 38px !important;
  border-radius: 8px;
  text-transform: none;
  letter-spacing: normal;
  font-size: 14px;
  font-weight: 600;
}
.privacy-text a {
  color: #205295 !important;
  text-decoration: underline;
  cursor: pointer;
}

/* ---------- Responsive ---------- */
@media (max-width: 959px) {
  .home-section {
    padding: 56px 0;
  }
  .hero-title {
    font-size: 38px;
    margin-top: 16px;
  }
  .hero-img-wrap {
    padding-left: 0;
    margin-top: 16px;
  }
  .pdpa-badge {
    left: 12px;
  }
  .section-title {
    font-size: 26px;
  }
  .app-title {
    font-size: 32px;
  }
  .app-desc {
    margin-left: auto;
    margin-right: auto;
  }
  .app-eyebrow {
    justify-content: center;
  }
  .privacy-text {
    white-space: normal;
  }
  .privacy-snackbar ::v-deep .v-snack__action {
    align-self: center !important;
    margin: 12px 0 4px !important;
  }
  .privacy-actions {
    justify-content: center;
  }
}
@media (max-width: 599px) {
  .hero-title {
    font-size: 32px;
  }
  .btn-group .home-btn {
    flex: 1;
  }
}

/* Animations */
.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.reveal--visible {
  opacity: 1;
  transform: translateY(0);
}
.getintouch_paragraph {
  opacity: 0;
  transform: translateY(60px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.getintouch_paragraph--visible {
  opacity: 1;
  transform: translateY(0);
}
</style>